<!-- 조직관리 > 회사관리 -->
<template>
  <div class="tabCont">
    <div class="content-inner-box">
      <div class="form-group col-ty">
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">
            {{t('message.companyName')}}
          </div>
          <div class="row">
            <div class="txt">{{`${clientName}(${companyName})`}}</div>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">
            {{t('message.department')}}<span class="imp">*</span>
          </div>
          <div class="row">
            <c-btn01
              :btnText="t('message.addOrEdit')"
              class="sm"
              @click.stop="openPopup('dept')"/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">
            {{t('message.position')}}<span class="imp">*</span>
          </div>
          <div class="row">
            <c-btn01
              :btnText="t('message.addOrEdit')"
              class="sm"
              @click.stop="openPopup('pos')"/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">
            {{t('message.shiftInfo')}}
          </div>
          <div class="row">
            <c-btn01
              :btnText="t('message.addOrEdit')"
              class="sm"
              @click="shiftDialog=true"/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">
            {{t('message.registeredMembers')}}
          </div>
          <div class="row">
            <c-btnText01 :btnText="memberCnt" @click.stop="moveTab()"/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">
            {{t('message.usageStatus')}}<span class="imp">*</span>
          </div>
          <div class="row">
            <v-switch v-model="useYn" inset hide-details true-value="Y" false-value="N" @change="changeSwitch('useYn')"></v-switch>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">
            {{t('message.changeInfo')}}
          </div>
          <div class="row">
            <c-btnText01 :btnText="historyCnt" @click="onClickChangeDialog()"/>
          </div>
        </div>
      </div>
    </div>
    <div class="tit-group" v-if="userInfo.roles == 'ADMIN1' || userInfo.roles == 'ADMIN2' || userInfo.roles == 'ADMIN3'">
      <h3 class="tit">{{t('message.moduleUsageManagement')}}</h3>
    </div>
    <div class="content-inner-box" v-if="userInfo.roles == 'ADMIN1' || userInfo.roles == 'ADMIN2' || userInfo.roles == 'ADMIN3'">
      <div class="form-group col-ty">
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.safetyCalender')}}</div>
          <div class="row">
            <v-switch v-model="moduleCalender" inset hide-details true-value="Y" false-value="N" @change="changeSwitch('moduleCalender')"></v-switch>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.behaviorBasedSafety')}}</div>
          <div class="row">
            <v-switch v-model="moduleBbs" inset hide-details true-value="Y" false-value="N" @change="changeSwitch('moduleBbs')"></v-switch>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.safetyLeadership')}}</div>
          <div class="row">
            <v-switch v-model="moduleLeadership" inset hide-details true-value="Y" false-value="N" @change="changeSwitch('moduleLeadership')"></v-switch>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.integratedReport')}}</div>
          <div class="row">
            <v-switch v-model="moduleReport" inset hide-details true-value="Y" false-value="N" @change="changeSwitch('moduleReport')"></v-switch>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.myBoard')}}</div>
          <div class="row">
            <v-switch v-model="moduleBoard" inset hide-details true-value="Y" false-value="N" @change="changeSwitch('moduleBoard')"></v-switch>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-btn-group">
      <div class="wl">
        <c-btnLine01 :btnText="t('message.list')" v-if="false"/>
      </div>
      <div class="wr">
        <c-btn02 :btnText="t('message.delete')" v-if="false"/>
        <c-btn01 :btnText="t('message.update')" @click="onClickSave" v-if="adminInfo?.authCompany >= 2 || userInfo.roles == 'ADMIN1' || userInfo.roles == 'ADMIN2'"/>
      </div>
    </div>
  </div>
  <!--부서-->
  <DialogDept02
    v-model="deptDialog"
    @close="deptDialog=false"
    @confirm="confirmTree"
  />
  <!--직책-->
  <!-- DialogDept02
    v-model="posDialog"
    :popTitle="t('message.position')"
    @close="posDialog=false"/-->
  <DialogShift
    v-model="shiftDialog"
    :popTitle="t('message.shiftWork')"
    @close="shiftDialog=false"
    @confirm="confirmTree"/>
  <!--변경정보-->
  <c-dialog v-model="dialogChangeNumModel"
            v-bind="dialogChangeNumBind"
            :dialogText="historyDialogText"
            @close="dialogChangeNumModel=false"
  />
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useCommonStore } from "@/store/common";
import { storeToRefs } from 'pinia'
import CompanyService from "@/services/company.service";
import LogService from "@/services/log.service";
import utils from "@/common/Utils";
import _ from 'lodash';
import dayjs from "dayjs";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//bind
const deptDialog = ref(false)
const posDialog = ref(false)
const shiftDialog = ref(false)
const dialogChangeNumModel = ref(false)
const clientName = ref('')
const companyName = ref('')
const memberCnt = ref('')
const useYn = ref('N')
const historyCnt = ref(0)
const moduleCalender = ref('N')
const moduleBbs = ref('N')
const moduleLeadership = ref('N')
const moduleReport = ref('N')
const moduleBoard = ref('N')
const historyDialogText = ref('')
const snackbar = ref(false)
const snackText = ref('')
const userInfo:any = ref(JSON.parse(localStorage.getItem('user')))
const adminInfo:any = ref(JSON.parse(localStorage.getItem("admin")))
let changeLog = []

//ui
const dialogChangeNumBind = ref({
  dialogTit: computed(() =>t('message.changeInfoFormat')),
  dialogText: '',
  btn1Show: true,
  btn1Text: computed(() =>t('message.confirm'))
})

//hook
onMounted(() => {
  getData()
})

//function
const getData = ()=>{
  let companyIdx = localStorage.getItem('companyIdx')

  let params = {
    idx: companyIdx,
  }

  CompanyService.getCompany(params).then(
    (response:any) => {
      clientName.value = response.result.clientName
      companyName.value = response.result.companyName
      memberCnt.value = response.result.memberCnt
      useYn.value = response.result.useYn
      historyCnt.value = response.result.historyCnt
      moduleCalender.value = response.result.moduleCalender
      moduleBbs.value = response.result.moduleBbs
      moduleLeadership.value = response.result.moduleLeadership
      moduleReport.value = response.result.moduleReport
      moduleBoard.value = response.result.moduleBoard
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const moveTab = ()=>{
  utils.movePage('/organizationalManagement/2/list')
}

const onClickChangeDialog = ()=>{
  let companyIdx = localStorage.getItem('companyIdx')
  let params = {
    tableType: 'company',
    parentIdx: companyIdx
  }
  LogService.getLogList(params).then(
    (response:any) => {
      let logContent = ''
      if(response.result.length > 0) {
        response.result.forEach((row)=> {
          logContent += `${row.changeLog} / ${row.memberId} / ${dayjs(row.regDate).format('YYYY-MM-DD HH:mm:ss')} <br>`
        });
      }

      if(logContent != '') {
        historyDialogText.value = utils.changeLogLanguage(logContent)
        dialogChangeNumModel.value = true
      }
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const changeSwitch = (id)=>{
  let companyIdx = localStorage.getItem('companyIdx')
  let value = useYn.value
  if(id == 'moduleCalender')
    value = moduleCalender.value
  if(id == 'moduleBbs')
    value = moduleBbs.value
  if(id == 'moduleLeadership')
    value = moduleLeadership.value
  if(id == 'moduleReport')
    value = moduleReport.value
  if(id == 'moduleBoard')
    value = moduleBoard.value
  let params = {
    idx: companyIdx,
    [id]: value
  }
  CompanyService.insertCompany(params).then(
    (response) => {
      if(!_.some(changeLog, id))
        changeLog.push(id)
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const openPopup = (type)=>{
  let companyIdx = localStorage.getItem('companyIdx')
  storeRef.popupIdx.value = companyIdx
  storeRef.popupType.value = type
  deptDialog.value = true
}

const onClickSave = ()=>{
  let companyIdx = localStorage.getItem('companyIdx')
  let params = {
    companyIdx: companyIdx,
    idx: companyIdx,
    tableType: 'company',
    changeLogTitle: '[update]',
    changeLogList: changeLog
  }
  LogService.insertLogList(params).then(
    (response) => {
      snackText.value = t('message.savedSuccessfully')
      snackbar.value = true
      historyCnt.value = historyCnt.value?historyCnt.value++:1
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const confirmTree = (item)=>{
  if(!_.some(changeLog, item))
    changeLog.push(item)
}
</script>


<style lang="scss" >
</style>
